var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单号/手机号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.keyword,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "keyword", $$v)
                                },
                                expression: "listPram.keyword",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.orderStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderStatus", $$v)
                                },
                                expression: "listPram.orderStatus",
                              },
                            },
                            _vm._l(_vm.orderStateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "过期状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.validityStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "validityStatus", $$v)
                                },
                                expression: "listPram.validityStatus",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "-1",
                                attrs: { label: "已过期", value: "-1" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                key: "1",
                                attrs: { label: "未过期", value: "1" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.handerSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.claerPamrs },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "订单号", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.orderNo) +
                                "\n            "
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-top": "4px" },
                                attrs: { type: "primary", size: "mini" },
                              },
                              [_vm._v("医疗服务订单")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "下单人手机",
                  "min-width": "190",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "套餐名称",
                  "min-width": "260",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderAmount",
                  label: "订单金额",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "wxPayAmount",
                  label: "微信支付",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fudouPayAmount",
                  label: "福豆支付",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderStatus",
                  label: "订单状态",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "validityStr",
                  label: "有效期",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderTime",
                  label: "订单时间",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payTime",
                  label: "支付时间",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "80",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "详情",
            visible: _vm.dialogVisibleDetals,
            width: "35%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleDetals = $event
            },
          },
        },
        [
          _c("div", { staticClass: "order-detail-dialog" }, [
            _c("section", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [_vm._v("基础信息")]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("span", [
                  _vm._v("订单编号：" + _vm._s(_vm.popupDetales.orderNo)),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("订单状态：\n            "),
                  _c("span", { staticStyle: { color: "#67C23A" } }, [
                    _vm._v(_vm._s(_vm.popupDetales.orderStatus)),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("下单时间：" + _vm._s(_vm.popupDetales.createTime)),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("订单金额：" + _vm._s(_vm.popupDetales.orderAmount)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("span", [
                  _vm._v("下单人昵称：" + _vm._s(_vm.popupDetales.productName)),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("下单人手机号：" + _vm._s(_vm.popupDetales.phone)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [_vm._v("商品信息")]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("span", [
                  _vm._v("商品名称：" + _vm._s(_vm.popupDetales.productName)),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("商品售价：" + _vm._s(_vm.popupDetales.price)),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("商品原价：" + _vm._s(_vm.popupDetales.originalPrice)),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("有效期：" + _vm._s(_vm.popupDetales.patientValidity)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("服务信息"),
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%", "margin-bottom": "10px" },
                    attrs: {
                      data: _vm.popupDetales.configInfoList,
                      border: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "serviceName", label: "服务名称" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "usedUsageCount", label: "已使用次数" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "usageCount", label: "剩余次数" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("section", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("绑定人信息"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("span", [
                  _vm._v("绑定人：" + _vm._s(_vm.popupDetales.patientName)),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("绑定时间：" + _vm._s(_vm.popupDetales.createTime)),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("性别：" + _vm._s(_vm.popupDetales.patientSex)),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("年龄：" + _vm._s(_vm.popupDetales.patientAge)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("span", [
                  _vm._v("联系电话：" + _vm._s(_vm.popupDetales.phone)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [_vm._v("支付信息")]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm._v("支付状态：" + _vm._s(_vm.popupDetales.orderStatus)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm._v("支付时间：" + _vm._s(_vm.popupDetales.payTime)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm._v("支付方式：" + _vm._s(_vm.popupDetales.payType)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm._v("微信支付：" + _vm._s(_vm.popupDetales.wxPayAmount)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm._v("微信交易号：" + _vm._s(_vm.popupDetales.wxOrderNo)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm._v("信息描述：" + _vm._s(_vm.popupDetales.remark)),
              ]),
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [_vm._v("支付明细")]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm._v("订单总价：" + _vm._s(_vm.popupDetales.orderAmount)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm._v("优惠：" + _vm._s(_vm.popupDetales.couponAmount)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [_vm._v("积分抵扣：0")]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm._v("福豆抵扣：" + _vm._s(_vm.popupDetales.fudouAmount)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm._v("订单实付款：" + _vm._s(_vm.popupDetales.wxPayAmount)),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }